import { EXAM_ROUTE, RATING_ROUTE } from "./names";
import Exam from "../views/exam/Exam";
import Rating from "../views/rating/Rating.vue";

export const examRoutes = [
  {
    path: "/exam",
    name: EXAM_ROUTE,
    component: Exam,
    meta: {
      type: "exam",
      group: "Учебная деятельность",
      title: "Ведомости",
      icon: "mdi-file-document-multiple",
      linked: true,
      breadcrumbs: [
        {
          text: "Главная",
          link: true,
          exact: true,
          to: { name: "home" }
        },
        {
          text: "Ведомости",
          disabled: true,
          link: true,
          to: { name: EXAM_ROUTE }
        }
      ]
    }
  },
  {
    path: "/rating",
    name: RATING_ROUTE,
    component: Rating,
    meta: {
      type: "rating",
      group: "Учебная деятельность",
      title: "Рейтинг",
      icon: "mdi-seal",
      linked: true,
      breadcrumbs: [
        {
          text: "Главная",
          link: true,
          exact: true,
          to: { name: "home" }
        },
        {
          text: "Рейтинг",
          disabled: true,
          link: true,
          to: { name: RATING_ROUTE }
        }
      ]
    }
  }
];
